var moment = require('moment')
var dateutils = require('./dateutils')

function normalizeLensIndex (lensIndex) {
  if (lensIndex === undefined || lensIndex === null) {
    return ''
  }

  let value = String(lensIndex).trim()
  if (value.length === 0) {
    return ''
  }

  let numericValue = Number(value)
  return isNaN(numericValue) ? value : numericValue.toFixed(2)
}

function normalizeLensIndexes (lensIndexes) {
  let normalised = []
  if (!lensIndexes) {
    return normalised
  }

  for (let i = 0; i < lensIndexes.length; i++) {
    let lensIndex = normalizeLensIndex(lensIndexes[i])
    if (lensIndex.length > 0 && normalised.indexOf(lensIndex) === -1) {
      normalised.push(lensIndex)
    }
  }
  return normalised
}

const state = {
  all: [],
  headers: ['campaignDocId', 'requesterEmail', 'requestedTaxInvoice', 'pairingTaxInvoice', 'status', 'rejectReason', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  showApproveOrRejectModal: false,
  showUpdatingModal: false,
  showUpdateSuccessModal: false,
  showUpdateFailedModal: false,
  updateFailMessage: '',
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false
}

const mutations = {
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
    // console.log('CHanged state page number to: ' + state.currentPage)
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
    // console.log('Mutated totalRows to: ' + state.totalRows)
  },
  selectTableRow: function (state, pairId) {
    for (let i = 0; i < state.all.length; i++) {
      if (state.all[i].pairRequestsDocId === pairId) {
        state.all[i]._rowVariant = 'info'
      } else {
        state.all[i]._rowVariant = ''
      }
    }
  },
  toggleshowApproveOrRejectModal: function (state, show) {
    state.showApproveOrRejectModal = show
  },
  toogleShowUpdatingModal: function (state, show) {
    state.showUpdatingModal = show
  },
  toggleShowUpdateSuccessModal: function (state, show) {
    state.showUpdateSuccessModal = show
  },
  toogleShowUpdateFailedModal: function (state, show) {
    state.showUpdateFailedModal = show
  },
  approveFailedAction: function (state, err) {
    console.log('err type: ' + typeof err)
    if (typeof err === 'string') {
      state.updateFailMessage = err
    } else if (err.message) {
      console.log('err message:' + err.message)
      state.updateFailMessage = err.message
    } else {
      state.updateFailMessage = err
    }
    state.showApproveOrRejectModal = false
    state.showUpdatingModal = false
    state.showUpdateFailedModal = true
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  }
}

const getters = {
  getAll: function (state, getters, rootState) {
    return state.all
  },
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  }
}

const actions = {
  showAllPairRequests (context, payload) {
    context.state.all = []

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    // count total rows
    let firstQuery = context.rootState.firestoreDB.collection('pairRequests')
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length)
    })

    if (context.state.currentPage === 1) {
      let docQuery = context.rootState.firestoreDB.collection('pairRequests')
        .orderBy(payload.orderBys, 'desc')
        .limit(context.state.rowsPerPage)
      docQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // console.log(doc.id + '=>' + doc.data())
          let documentData = doc.data()
          let invoiceObject = {}
          for (let eachProp in documentData) {
            let propName = eachProp
            // console.log('eachProp: ' + eachProp)
            if (propName === 'createdDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else {
              invoiceObject[propName] = doc.data()[eachProp]
            }
          }
          invoiceObject.pairId = doc.id
          invoiceObject._rowVariant = ''
          context.state.all.push(invoiceObject)
        })
        context.commit('toggleShowLoadingAnimation', false)
        if (context.state.all.length === 0) {
          context.commit('toggleShowNoResult', true)
        }
      }).catch(function (err) {
        console.log('Error while fetching documents: ' + err)
        context.commit('toggleShowLoadingAnimation', false)

        context.commit('toggleshowLoadingError', true)
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
      })
    } else {
      let lastRowShown
      if (context.state.currentPage === 2) {
        lastRowShown = context.state.rowsPerPage
      } else {
        lastRowShown = ((context.state.currentPage - 1) * context.state.rowsPerPage)
      }
      console.log('lastRowShown: ' + lastRowShown)
      let docQuery = context.rootState.firestoreDB.collection('users')
        .orderBy(payload.orderBys)
      docQuery.get().then(function (querySnapshot) {
        let lastVisibleSnapshot = querySnapshot.docs[lastRowShown]

        let docSubQuery = context.rootState.firestoreDB.collection('pairRequests')
          .orderBy(payload.orderBys, 'desc')
          .startAt(lastVisibleSnapshot)
          .limit(context.state.rowsPerPage)
        docSubQuery.get().then(function (subQuerySnapshot) {
          subQuerySnapshot.forEach(function (subDoc) {
            // console.log(subDoc.id + '=>' + subDoc.data())
            let documentData = subDoc.data()
            let invoiceObject = {}
            for (let eachProp in documentData) {
              let propName = eachProp
              // console.log('eachProp: ' + eachProp)
              // invoiceObject[propName] = subDoc.data()[eachProp]
              // context.state.headers.push(propName)
              if (propName === 'createdDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else if (propName === 'updatedDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else {
                invoiceObject[propName] = subDoc.data()[eachProp]
              }
            }
            invoiceObject.pairId = subDoc.id
            invoiceObject._rowVariant = ''
            context.state.all.push(invoiceObject)
          })
          context.commit('toggleShowLoadingAnimation', false)
          if (context.state.all.length === 0) {
            context.commit('toggleShowNoResult', true)
          }
        })
      }).catch(function (err) {
        console.log('Error while fetching documents: ' + err)
        context.commit('toggleShowLoadingAnimation', false)

        context.commit('toggleshowLoadingError', true)
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
      })
    }
  },
  filterTable: function (context, payload) {
    if (!payload) {
      return
    }
    let haveFilter = false
    for (let i in payload) {
      // console.log('payload[i]:' + payload[i])
      if (payload[i] && payload[i].length > 0) {
        haveFilter = true
      }
    }
    if (!haveFilter) {
      return
    }

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    context.state.all = []
    context.state.detailAll = []
    context.commit('updateTotalRows', 0)

    let docQuery = context.rootState.firestoreDB.collection('pairRequests')
    for (let i in payload) {
      if (payload[i] && payload[i].length > 0) {
        // console.log('where ' + i + '==' + payload[i])
        docQuery = docQuery.where(i, '==', payload[i])
      }
    }

    if (!docQuery) {
      return
    }

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size)
      querySnapshot.forEach(function (doc) {
        // console.log(doc.id + '=>' + doc.data())
        let documentData = doc.data()
        let invoiceObject = {}
        for (let eachProp in documentData) {
          let propName = eachProp
          // console.log('eachProp: ' + eachProp)
          if (propName === 'orderDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY')
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else {
            invoiceObject[propName] = doc.data()[eachProp]
          }
        }
        invoiceObject.pairId = doc.id
        invoiceObject._rowVariant = ''
        context.state.all.push(invoiceObject)
      })
      context.commit('toggleShowLoadingAnimation', false)
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true)
      }
    }).catch(function (err) {
      console.log('Error while fetching documents: ' + err)
      context.commit('toggleShowLoadingAnimation', false)

      context.commit('toggleshowLoadingError', true)
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    })
  },
  approveRequest (context, payload) {
    context.state.updateFailMessage = ''
    if (payload && payload.pairRequestsDocId) {
      context.commit('toogleShowUpdatingModal', true)
      console.log('Approving request...')
      context.dispatch('createInvoiceLockingDataFirstCheck', payload)
    }
  },
  createInvoiceLockingDataFirstCheck (context, payload) {
    // 1. check user account status
    console.log('Checking requester user account')
    context.rootState.firestoreDB.collection('users').doc(payload.requester).get()
      .then(function (doc) {
        if (doc.exists) {
          let data = doc.data()
          if (data.approved === false) {
            console.error('User not approved yet, cannot approve pairing request')
            return Promise.reject(new Error('User not approved yet, cannot approve pairing request'))
          } else if (data.status !== 'ACTIVE') {
            console.error('User status is not ACTIVE yet, cannot approve pairing request')
            return Promise.reject(new Error('User status is not ACTIVE yet, cannot approve pairing request'))
          } else {
            context.dispatch('createInvoiceLockingDataSecondCheck', payload)
          }
        } else {
          console.error(payload.requester + ' does not exists, cannot approve pairing request')
          return Promise.reject(new Error(payload.requester + ' does not exists, cannot approve pairing request'))
        }
      })
      .catch(function (err) {
        console.error('Err:' + err)
        context.commit('approveFailedAction', err)
        context.dispatch('showAllPairRequests', { orderBys: 'createdDate' })
      })
  },
  createInvoiceLockingDataSecondCheck (context, payload) {
    // 2. fetch campaign, check campaign status, check money pool, check campaign if started or ended
    console.log('Checking campaign')
    context.rootState.firestoreDB.collection('campaigns').doc(payload.campaignId)
      .get().then(function (doc) {
        let campaignObject = null
        if (doc.exists) {
          let data = doc.data()
          campaignObject = {
            campaignId: data.id,
            name: data.name,
            description: data.description,
            status: data.status,
            startDate: data.startDate,
            endDate: data.endDate,
            invoiceStartDate: data.invoiceStartDate,
            invoiceEndDate: data.invoiceEndDate,
            minimumPrice: data.minimumPrice,
            lensDesigns: data.lensDesigns,
            orderTypes: data.orderTypes,
            lensIndexes: data.lensIndexes || []
          }
          if (campaignObject.status !== 'ACTIVE') {
            console.error('Campaign is not ACTIVE, cannot approve pairing request')
            return Promise.reject(new Error('Campaign is not ACTIVE, cannot approve pairing request'))
          } else {
            let today = new Date()
            if (dateutils.toJsDate(campaignObject.startDate) > today) {
              console.error('Campaign has not start, cannot approve pairing request')
              return Promise.reject(new Error('Campaign has not start, cannot approve pairing request'))
            } else if (dateutils.toJsDate(campaignObject.endDate) < today) {
              console.error('Campaign has ended, cannot approve pairing request')
              return Promise.reject(new Error('Campaign has ended, cannot approve pairing request'))
            } else {
              payload.campaignObject = campaignObject
              context.dispatch('createInvoiceLockingDataThirdCheck', payload)
            }
          }
        } else {
          console.error('Campaign does not exists, cannot approve pairing request')
          return Promise.reject(new Error('Campaign does not exists, cannot approve pairing request'))
        }
      })
      .catch(function (err) {
        console.error('Err:' + err)
        context.commit('approveFailedAction', err)
        context.dispatch('showAllPairRequests', { orderBys: 'createdDate' })
      })
  },
  createInvoiceLockingDataThirdCheck (context, payload) {
    // 3. check money pool
    context.rootState.realtimeDb.ref('campaigns/' + payload.campaignId).once('value').then(function (snapshot) {
      if (snapshot && snapshot.val()) {
        let totalPrizeMoney = Number(snapshot.val().totalPrizeMoney)
        let claimed = Number(snapshot.val().claimedPrizeMoney)

        if (claimed >= totalPrizeMoney) {
          console.error('Campaign has no more money to claim')
          return Promise.reject(new Error('Campaign has no more money to claim'))
        } else {
          context.dispatch('createClaimPlaceHolderAndProceed', payload)
        }
      }
    })
      .catch(function (err) {
        console.error('Err:' + err)
        context.commit('approveFailedAction', err)
        context.dispatch('showAllPairRequests', { orderBys: 'createdDate' })
      })
  },
  createClaimPlaceHolderAndProceed (context, payload) {
    console.log('Creating claim place holder')
    // create a claims document as placeholder first, so that we can update it in the transaction
    let claimDocPlaceHolder = {createdDate: new Date(), createdBy: 'admin'}
    context.rootState.firestoreDB.collection('claims').add(claimDocPlaceHolder).then(function (doc) {
      payload.claimsPlaceHolderId = doc.id
      context.dispatch('fetchInvoicesSubTypesAndProceed', payload)
    })
      .catch(function (err) {
        console.error('Err:' + err)
        context.commit('approveFailedAction', err)
        context.dispatch('showAllPairRequests', { orderBys: 'createdDate' })
      })
  },
  fetchInvoicesSubTypesAndProceed (context, payload) {
    context.rootState.firestoreDB.collection('invoices').doc(payload.invoiceNumberOne).collection('subtypes')
      .get().then(function (querySnapshot) {
        let invoiceOneSubtypes = []
        querySnapshot.forEach(function (doc) {
          if (doc.exists) {
            let invoiceOneSubtype = doc.data()
            invoiceOneSubtype.id = doc.id
            invoiceOneSubtypes.push(invoiceOneSubtype)
          }
        })
        if (invoiceOneSubtypes.length === 0) {
          console.error('No available quantity in invoice one, cannot approve pairing request')
          return Promise.reject(new Error('No available quantity in invoice one, cannot approve pairing request'))
        } else {
          context.rootState.firestoreDB.collection('invoices').doc(payload.invoiceNumberTwo).collection('subtypes')
            .get().then(function (querySnapshotTwo) {
              let invoiceTwoSubtypes = []
              querySnapshotTwo.forEach(function (doc) {
                if (doc.exists) {
                  let invoiceTwoSubtype = doc.data()
                  invoiceTwoSubtype.id = doc.id
                  invoiceTwoSubtypes.push(invoiceTwoSubtype)
                }
              })
              if (invoiceTwoSubtypes.length === 0) {
                console.error('No available quantity in invoice two, cannot approve pairing request')
                return Promise.reject(new Error('No available quantity in invoice two, cannot approve pairing request'))
              } else {
                payload.invoiceOneSubtypes = invoiceOneSubtypes
                payload.invoiceTwoSubtypes = invoiceTwoSubtypes
                context.dispatch('createInvoiceLockingDataForthCheck', payload)
              }
            })
            .catch(function (err) {
              console.error('Err:' + err)
              context.commit('approveFailedAction', err)
              context.dispatch('showAllPairRequests', { orderBys: 'createdDate' })
            })
        }
      })
      .catch(function (err) {
        console.error('Err:' + err)
        context.commit('approveFailedAction', err)
        context.dispatch('showAllPairRequests', { orderBys: 'createdDate' })
      })
  },
  createInvoiceLockingDataForthCheck (context, payload) {
    // 4. fetch invoices, check invoice status, check who is claiming, check invoice date
    // fetch invoices subtypes, check lens designs and order types, count available quantity
    console.log('Checking invoice one')
    let invoiceOneRef = context.rootState.firestoreDB.collection('invoices').doc(payload.invoiceNumberOne)
    let invoiceTwoRef = context.rootState.firestoreDB.collection('invoices').doc(payload.invoiceNumberTwo)

    let claimDocRef = context.rootState.firestoreDB.collection('claims').doc(payload.claimsPlaceHolderId)
    let pairRequestRef = context.rootState.firestoreDB.collection('pairRequests').doc(payload.pairRequestsDocId)

    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(invoiceOneRef).then(function (doc) {
        if (doc.exists) {
          let data = doc.data()
          let invoiceOneUpdateObject = {}
          if (data.status === 'CLAIMING' && data.claimEmail !== payload.requester) {
            console.error('Other people are claiming this invoice, cannot approve pairing request')
            return Promise.reject(new Error('Other people are claiming this invoice, cannot approve pairing request'))
          } else {
            // proceed to check invoice 2
            console.log('proceed to check invoice 2')
            return transaction.get(invoiceTwoRef).then(function (doc) {
              if (doc.exists) {
                let dataTwo = doc.data()
                if (dataTwo.status === 'CLAIMING' && dataTwo.claimEmail !== payload.requester) {
                  console.error('Other people are claiming this invoice, cannot approve pairing request')
                  return Promise.reject(new Error('Other people are claiming this invoice, cannot approve pairing request'))
                } else {
                  if (data.status === 'NEW') {
                    console.log('Found unlock invoice one, locking it...')
                    invoiceOneUpdateObject.status = 'CLAIMING'
                    invoiceOneUpdateObject.claimEmail = payload.requester
                  }
                  // firebase transaction require us to write after every read, so we write back the same data
                  invoiceOneUpdateObject.updatedDate = new Date()
                  invoiceOneUpdateObject.updatedBy = 'admin'

                  let invoiceTwoUpdateObject = {}
                  if (dataTwo.status === 'NEW') {
                    console.log('Found unlocked invoice two, locking it...')
                    invoiceTwoUpdateObject.status = 'CLAIMING'
                    invoiceTwoUpdateObject.claimEmail = payload.requester
                  }
                  // firebase transaction require us to write after every read, so we write back the same data
                  invoiceTwoUpdateObject.updatedDate = new Date()
                  invoiceTwoUpdateObject.updatedBy = 'admin'

                  // before update invoice, we should check subtypes, check lens designs and order types, count available quantity
                  let invoiceOneAvailableSubtype = null
                  for (let i = 0; i < payload.invoiceOneSubtypes.length; i++) {
                    let claimedQuantity = 0
                    if (payload.invoiceOneSubtypes[i].claimedQuantity) {
                      claimedQuantity = payload.invoiceOneSubtypes[i].claimedQuantity
                    }
                    let subTypeAvailableQuantity = 0
                    if (Number(claimedQuantity) < Number(payload.invoiceOneSubtypes[i].quantity)) {
                      subTypeAvailableQuantity = Number(payload.invoiceOneSubtypes[i].quantity) - Number(claimedQuantity)
                    }
                    if (subTypeAvailableQuantity > 0) {
                      invoiceOneAvailableSubtype = payload.invoiceOneSubtypes[i]
                      break
                    }
                  }
                  let invoiceTwoAvailableSubtype = null
                  for (let i = 0; i < payload.invoiceTwoSubtypes.length; i++) {
                    let claimedQuantity = 0
                    if (payload.invoiceTwoSubtypes[i].claimedQuantity) {
                      claimedQuantity = payload.invoiceTwoSubtypes[i].claimedQuantity
                    }
                    let subTypeAvailableQuantity = 0
                    if (Number(claimedQuantity) < Number(payload.invoiceTwoSubtypes[i].quantity)) {
                      subTypeAvailableQuantity = Number(payload.invoiceTwoSubtypes[i].quantity) - Number(claimedQuantity)
                    }
                    if (subTypeAvailableQuantity > 0) {
                      invoiceTwoAvailableSubtype = payload.invoiceTwoSubtypes[i]
                      break
                    }
                  }
                  if (invoiceOneAvailableSubtype && invoiceTwoAvailableSubtype) {
                    console.log('Both invoice subtype has enough quantity for claim')
                    // now we check if both lens design and order type acceptable
                    let campaignLensIndexes = normalizeLensIndexes(payload.campaignObject.lensIndexes)
                    let invoiceOneLensIndex = normalizeLensIndex(invoiceOneAvailableSubtype.lensIndex)
                    let invoiceTwoLensIndex = normalizeLensIndex(invoiceTwoAvailableSubtype.lensIndex)
                    console.log('Invoice one lens pass: ' + payload.campaignObject.lensDesigns.indexOf(invoiceOneAvailableSubtype.lensDesign))
                    console.log('Invoice one order type pass: ' + payload.campaignObject.orderTypes.indexOf(invoiceOneAvailableSubtype.orderType))
                    console.log('Invoice one lens index pass: ' + campaignLensIndexes.indexOf(invoiceOneLensIndex))
                    console.log('Invoice two lens pass: ' + payload.campaignObject.lensDesigns.indexOf(invoiceTwoAvailableSubtype.lensDesign))
                    console.log('Invoice two order type pass: ' + payload.campaignObject.orderTypes.indexOf(invoiceTwoAvailableSubtype.orderType))
                    console.log('Invoice two lens index pass: ' + campaignLensIndexes.indexOf(invoiceTwoLensIndex))

                    let skipLensIndexCheck = campaignLensIndexes.length === 0

                    if (payload.campaignObject.lensDesigns.indexOf(invoiceOneAvailableSubtype.lensDesign) !== -1 &&
                        payload.campaignObject.orderTypes.indexOf(invoiceOneAvailableSubtype.orderType) !== -1 &&
                        (skipLensIndexCheck || campaignLensIndexes.indexOf(invoiceOneLensIndex) !== -1) &&
                        payload.campaignObject.lensDesigns.indexOf(invoiceTwoAvailableSubtype.lensDesign) !== -1 &&
                        payload.campaignObject.orderTypes.indexOf(invoiceTwoAvailableSubtype.orderType) !== -1 &&
                        (skipLensIndexCheck || campaignLensIndexes.indexOf(invoiceTwoLensIndex) !== -1)) {
                      console.log('Both invoice subtype lens design, order type and lens index fulfill campaign requirement')
                      // hence we can update the invoices and also claims
                      transaction.update(invoiceOneRef, invoiceOneUpdateObject)
                      transaction.update(invoiceTwoRef, invoiceTwoUpdateObject)
                      let claimObject = {
                        campaignDocId: payload.campaignId,
                        updatedDate: new Date(),
                        updatedBy: 'admin',
                        claimEmail: payload.requester,
                        taxInvoice: payload.invoiceNumberOne,
                        subtypes: [
                          {
                            claimQuantity: 1,
                            subTypeDocId: invoiceOneAvailableSubtype.id
                          }
                        ],
                        status: 'CLAIMING',
                        paired: true,
                        taxInvoiceTwo: payload.invoiceNumberTwo,
                        subtypesTwo: [
                          {
                            claimQuantity: 1,
                            subTypeDocId: invoiceTwoAvailableSubtype.id
                          }
                        ]
                      }
                      transaction.update(claimDocRef, claimObject)
                      transaction.update(pairRequestRef, {status: 'APPROVED'})
                    } else {
                      console.error('Invoice subtype does not meet campaign lens design, order type and lens index')
                      return Promise.reject(new Error('Invoice subtype does not meet campaign lens design, order type and lens index'))
                    }
                  }
                }
              } else {
                console.error('Invoice data does not exists, cannot approve pairing request')
                return Promise.reject(new Error('Invoice data does not exists, cannot approve pairing request'))
              }
            })
          }
        } else {
          console.error('Invoice data does not exists, cannot approve pairing request')
          return Promise.reject(new Error('The invoice had been locked by other people'))
        }
      })
    }).then(function () {
      console.log('All transaction in approve request completed')
      context.dispatch('showAllPairRequests', {orderBys: 'createdDate'})
      context.commit('toggleshowApproveOrRejectModal', false)
      context.commit('toogleShowUpdatingModal', false)
      context.commit('toggleShowUpdateSuccessModal', true)
    }).catch(function (err) {
      console.error('Err:' + err)
      context.commit('approveFailedAction', err)
      context.dispatch('showAllPairRequests', { orderBys: 'createdDate' })
    })
  },
  rejectRequest (context, payload) {
    context.state.updateFailMessage = ''
    if (payload && payload.pairRequestsDocId) {
      context.commit('toogleShowUpdatingModal', true)
      console.log('Rejecting request...')
      let pairRequestRef = context.rootState.firestoreDB.collection('pairRequests').doc(payload.pairRequestsDocId)

      context.rootState.firestoreDB.runTransaction(function (transaction) {
        return transaction.get(pairRequestRef).then(function (doc) {
          if (doc && doc.exists) {
            transaction.update(pairRequestRef,
              {
                status: 'REJECT',
                rejectReason: payload.rejectReason
              }
            )
          }
        })
      }).then(function () {
        console.log('REquest rejected')
        context.dispatch('showAllPairRequests', {orderBys: 'createdDate'})
        context.commit('toggleshowApproveOrRejectModal', false)
        context.commit('toogleShowUpdatingModal', false)
        context.commit('toggleShowUpdateSuccessModal', true)
      }).catch(function (err) {
        console.error('Err:' + err)
        context.commit('approveFailedAction', err)
        context.dispatch('showAllPairRequests', { orderBys: 'createdDate' })
      })
    }
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/pairrequestsstoremodule.js